import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import MuiInput, { InputProps as MuiInputProps } from '@mui/material/Input';

export type InputProps = MuiTextFieldProps & Partial<MuiInputProps> & { disableUnderline?: boolean };

export const Input = ({ disableUnderline, ...props }: InputProps) => {
  if (disableUnderline) {
    return <MuiInput disableUnderline {...(props as MuiInputProps)} />;
  }

  return <MuiTextField {...(props as MuiTextFieldProps)} variant="outlined" />;
};
